import * as PIXI from "pixi.js";
import SpriteGenerator from "../generators/SpriteGenerator";
import { convertSize } from "../utils";

function showCatchEffect({ app }) {
  this.catch_effect_sprite.visible = true;
  this.vy = 0;

  this.drop_sprite.visible = false;

  setTimeout(() => {
    // this.catch_effect_sprite.visible = false;
    this.destroy();
  }, 88);
}

export function loadDrops({
  renderer,
  texture,
  catch_effect_texture,
  parent,
  layout = { width: 0, height: 0 },
  vy = 2,
  count
}) {
  const drops = [];
  const screen_width = renderer.screen.width;
  const sprite_layout = {
    width: convertSize(layout.width, window.innerWidth),
    height: convertSize(layout.height, window.innerWidth)
  };
  const catch_effect_layout = {
    width: convertSize(92, window.innerWidth),
    height: convertSize(55, window.innerWidth)
  };

  this.letItRain({
    count,
    callback: () => {
      const sprite_offset_x =
        Math.abs(catch_effect_layout.width - sprite_layout.width) / 2;

      const drop = new PIXI.Container();
      drop.x = Math.floor(
        Math.random() * (screen_width - sprite_layout.width - sprite_offset_x)
      );
      drop.y = 0 - sprite_layout.height;
      drop.catched = false;
      drop.vy = vy;

      const sprite = SpriteGenerator({
        y: 0,
        x: sprite_offset_x,
        ...sprite_layout,
        texture
      });

      const catch_effect_sprite = SpriteGenerator({
        y: 0,
        ...catch_effect_layout,
        texture: catch_effect_texture
      });

      catch_effect_sprite.visible = false;

      drop.drop_sprite = sprite;
      drop.catch_effect_sprite = catch_effect_sprite;

      drop.showCatchEffect = showCatchEffect.bind(drop);

      // Hit Zone
      // 100 130
      // top 15

      drop.addChild(sprite);
      drop.addChild(catch_effect_sprite);

      parent.addChild(drop);
      drops.push(drop);
    }
  });

  return drops;
}
